import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';
import { messageTemplatesApiQueryKeys } from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.queryKeys.ts';
import {
  MessageChannel,
  MessageTemplateDto,
} from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

export const getMessageTemplatesQueryOptions = (
  channel: MessageChannel,
): UseQueryOptions<MessageTemplateDto[]> => ({
  queryKey: messageTemplatesApiQueryKeys.all(channel),
  queryFn: () => messageTemplatesApi.getAll(channel),
});

const useGetMessageTemplates = (channel: MessageChannel) => {
  return useQuery(getMessageTemplatesQueryOptions(channel));
};

export default useGetMessageTemplates;
